import React from 'react';

import styles from './styles.module.scss';

import ImageWithLoader from '@components/_shared/imageWithLoader';
import { FeeStructureLandingType } from '@utils/types/landings';
import { Logo } from '@assets/icons';
import { colors } from '@utils/constants/colors';

const RovePlus = (props: FeeStructureLandingType['rovePlus']) => {
  const { title, subtitle, items } = props;

  return (
    <div className={styles.rovePlus}>
      <div className={styles.rovePlus__wrapper}>
        <div className={styles.rovePlus__subtitle}>
          <Logo fill={colors.roveDarkGreen} />+
        </div>

        <h2 className={styles.rovePlus__title}>{title}</h2>

        <div className={styles.rovePlus__description}>{subtitle}</div>

        <div className={styles.rovePlus__items}>
          {items.map((item, key) => (
            <div key={key} className={styles.rovePlus__item}>
              <ImageWithLoader
                containerStyle={styles.rovePlus__image}
                src={item.image}
                alt={title}
                sizes="(max-width: 1024px) 100vw,
                       33vw"
              />

              <div className={styles.rovePlus__itemTitle}>{item.title}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RovePlus;
